/**
 * V2 brand palette — single source of truth (Brand core).
 * Maroon · primary, Maroon dark · hover, Cream · canvas, Cream deep · surfaces.
 */
/** Display / section headings — Foregen with serif fallbacks */
export const v2DisplayFontFamily = '"Foregen", "Roboto Slab", Georgia, serif';

export const v2Colors = {
  primary: '#A52A3C',
  primaryDark: '#8B1F30',
  canvas: '#F8E8CC',
  surface: '#F0DCB8',
  selectedFill: '#F9E1E1',
  white: '#FFFFFF',
  /** Section titles (Deliver to, Choose your slot, Checkout, etc.) */
  heading: '#1A130F',
  /** Inactive stepper labels */
  stepLabelInactive: '#9A7B5E',
  /** Disabled / unavailable slot text */
  slotDisabled: '#8A7D73',
  /** Completed step / arrival banner */
  success: '#3A5A40',
  textMuted: '#8B7E74',
  tagFill: '#F5EAD6',
  tagText: '#5C4A3A',
  primaryMuted: 'rgba(165, 42, 60, 0.65)',
  border: 'rgba(139, 31, 48, 0.22)',
  borderMuted: 'rgba(90, 60, 50, 0.28)',
};

/** Semantic aliases for layout / non-MUI usage */
export const v2Theme = {
  palette: {
    primary: v2Colors.primary,
    primaryDark: v2Colors.primaryDark,
    background: v2Colors.canvas,
    surface: v2Colors.surface,
    selectedFill: v2Colors.selectedFill,
    white: v2Colors.white,
    border: v2Colors.border,
    borderMuted: v2Colors.borderMuted,
    primaryMuted: v2Colors.primaryMuted,
    heading: v2Colors.heading,
    stepLabelInactive: v2Colors.stepLabelInactive,
    slotDisabled: v2Colors.slotDisabled,
    success: v2Colors.success,
    textMuted: v2Colors.textMuted,
  },
};
